export const STOREMAPPER_CONTAINER = 'storemapper';

export const GEOLOCATION_TIMEOUT = 15_000;
export const GEOLOCATION_MAX_AGE = 60_000;
export const MAP_ZOOM_LEVEL = 15;
export const CHECK_INTERVAL = 100;
export const MAX_WAIT_TIME = 10_000;

export const GEOLOCATION_BTN_CLASS = 'store-locator__geolocation-btn';
export const GEOLOCATION_BTN_LABEL = 'Find my location';
